// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.title {
  color: #0669B3;
}

.text-color {
  color: #0669B3;
  font-family: 500;
}

.outer-container {
  padding: 20px 40px;
}
.outer-container .heading {
  font-size: 1.1rem;
  font-weight: 600;
  color: #0669B3;
  margin-bottom: 30px;
}
.outer-container .instructions-container .top-sentence {
  color: #0669B3;
  font-weight: 550;
}
.outer-container .instructions-container .number-container {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.outer-container .instructions-container .number-container .number {
  border: 2px solid #0669B3;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  min-height: 40px;
  min-width: 40px;
  color: #0669B3;
  margin-right: 10px;
}
.outer-container .instructions-container .number-container .instruction {
  color: #0669B3;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/DcsdModalStyling.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AALA;EACI,cDsBS;ACdb;;AANA;EACI,cDmBS;EClBT,gBAAA;AASJ;;AANA;EACI,kBAAA;AASJ;AANI;EACI,iBAAA;EACA,gBAAA;EACA,cDQK;ECPL,mBAAA;AAQR;AALQ;EACI,cDGC;ECFD,gBAAA;AAOZ;AALQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAOZ;AALY;EACI,yBAAA;EC/BZ,mBDgCkC;EACtB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cDdH;ECeG,kBAAA;AAOhB;AALY;EACI,cDlBH;ACyBb","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n// // ! Important ! //\n// // All styling that needs to be done for Open Enrollment modals (text & layout) is done in this SINGLE file\n.title {\n    color: $pearl-blue;\n}\n.text-color {\n    color: $pearl-blue;\n    font-family: 500;\n}\n\n.outer-container {\n    padding: 20px 40px;\n\n\n    .heading {\n        font-size: 1.1rem;\n        font-weight: 600;\n        color: $pearl-blue;\n        margin-bottom: 30px;\n    }\n    .instructions-container {\n        .top-sentence {\n            color: $pearl-blue;\n            font-weight: 550;\n        }\n        .number-container {\n            display: flex;\n            align-items: center;\n            margin-top: 20px;\n\n            .number {\n                border: 2px solid $pearl-blue;\n                @include borderRadius(40px);\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.5rem;\n                min-height: 40px;\n                min-width: 40px;\n                color: $pearl-blue;\n                margin-right: 10px;\n            }\n            .instruction {\n                color: $pearl-blue;\n            }\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
